
define('modules/application/wizard/steps/zoneStep/complexZoneStep/zoneModel',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Classes
  "../zoneModel",
  "./zoneCollection"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneModel,
  ZoneCollection) {

  var complexZoneStepZoneModel = ZoneModel.extend({

    addConstructors                    : function()  {
      ZoneModel.prototype.addConstructors.apply(this);
      this.ZoneCollection = ZoneCollection;
    },

    initialize                         : function()  {
      var i=0, j=0;
      this.unbind("change:name",                      this.nameChangedEventHandler);
      this.bind("change:name",                        this.nameChangedEventHandler, this);

      if (!this.get("zoneEventAggregator"))
        this.set("zoneEventAggregator", _.extend({}, Backbone.Events));
    },

    isValid                            : function() {
      return this.get("valid");
    }

  });

  // Required, return the module for AMD compliance
  return complexZoneStepZoneModel;

});